angular.module('bmsApp.settings').controller('TableManagerCtrl', [
    '$scope',
    '$log',
    'TableManagerSvc',
    '$stateParams',
    '$state',
    'TableManagerObject',
    'notify',
    function ($scope, $log, TableManagerSvc, $stateParams, $state, TableManagerObject, notify) {
        $scope.settingData = {};
        $scope.loading = true;
        $scope.processing = false;
        $scope.displayName = $state.current.data.displayName;
        var model = $state.current.data.model;

        TableManagerSvc.index({model: model})
            .then(function (response) {
                $scope.settingData = response.data.modelValues;
                $scope.loading = false;
            }, function (error) {
                $scope.errors = error;
            });


        $scope.submit = function (settingData) {
            $scope.processing = true;
            var data = {data: settingData, modelName: model};
            TableManagerSvc.update(data)
                .then(function (response) {
                    notify({
                        message: 'List saved'
                    });
                }, function (error) {
                    $scope.errors = error;
                })
                .finally(function () {
                    $scope.processing = false;
                });

        };

        $scope.setEditable = function (setting) {
            setting.editing = true;

        }
        $scope.cancelEditing = function (setting) {
            setting.editing = false;
        }

        $scope.save = function (setting) {
            setting.editing = false;
        }

        $scope.delete = function (setting, index) {
            if (setting.newlyAdded) {
                $scope.settingData.splice(index, 1);
            }
            else {
                setting.deleted = true;
            }
        }

        $scope.reinstate = function (setting) {
            setting.deleted = false;
        }

        $scope.addNew = function () {
            var obj = {
                id: '',
                deleted: false,
                name: ''
            };
            $scope.settingData.push(obj);
            obj.editing = true;
            obj.newlyAdded = true;
        }

    }]);
